export const STATUS_MAP = {
    completed: 'done',
    'pre-translating': 'queued',
    pending: 'queued',
    'in-progress': 'live',
};

export const statusFor = (p) => {
    if (p.archivedAt) return 'done';
    // Explicit lifecycle set by the user on the Project Settings tab wins
    // over progress-derived status. "hold" is rendered as "blocked".
    if (p.lifecycleStatus === 'done') return 'done';
    if (p.lifecycleStatus === 'hold') return 'blocked';
    if (p.lifecycleStatus === 'live') {
        if (p.progress >= 85) return 'review';
        return 'live';
    }
    if (p.completed || p.status === 'completed') return 'done';
    if (p.progress >= 85) return 'review';
    if (p.blocked) return 'blocked';
    if (!p.progress || p.progress === 0 || p.status === 'pending' || p.status === 'pre-translating') return 'queued';
    return 'live';
};

export const ext = (p) => {
    const fname = p.fileName || p.sourceFile || p.originalFileType || '';
    const m = /\.?([a-z0-9]+)$/i.exec(fname);
    return ((m ? m[1] : 'doc')).slice(0, 3).toUpperCase();
};

export const fileClass = (e) => {
    const c = e.toLowerCase();
    if (c === 'idm' || c === 'idml') return 'idm';
    if (c === 'jso' || c === 'json') return 'jso';
    if (c === 'xli' || c === 'xlf') return 'xli';
    if (c === 'md') return 'md';
    return '';
};

export const langCode = (l) => {
    if (!l) return '';
    if (typeof l === 'string') return l.slice(0, 2).toUpperCase();
    return (l.code || l.value || '').slice(0, 2).toUpperCase();
};

export const targetCodes = (p) => {
    if (Array.isArray(p.targetLanguages) && p.targetLanguages.length) return p.targetLanguages.map(langCode);
    if (p.targetLanguage) return [langCode(p.targetLanguage)];
    return [];
};

export const sourceCode = (p) => langCode(p.sourceLanguage) || 'EN';

export const ownerInitials = (m, idx) => {
    if (!m) return `U${idx}`;
    const n = `${m.firstName || ''} ${m.lastName || ''}`.trim();
    if (n) return n.split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
    return (m.email || `U${idx}`).slice(0, 2).toUpperCase();
};

export const avatarPalette = (idx) => `av-${(idx % 6) + 1}`;

export const formatDue = (deadline) => {
    if (!deadline) return '—';
    const d = new Date(deadline);
    if (Number.isNaN(d.getTime())) return '—';
    const diff = Math.round((d - Date.now()) / (1000 * 60 * 60 * 24));
    if (diff < 0) return 'Overdue';
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Tomorrow';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export const dueClass = (deadline, status) => {
    if (!deadline || status === 'done') return '';
    const diff = Math.round((new Date(deadline) - Date.now()) / (1000 * 60 * 60 * 24));
    if (diff < 0) return 'warn';
    if (diff <= 1) return 'soon';
    return '';
};

export const progressOf = (p) => {
    if (p.progress != null && p.progress !== '') {
        const n = Number(p.progress);
        if (Number.isFinite(n)) return Math.round(n);
    }
    if (Array.isArray(p.sections) && p.sections.length) {
        const approved = (p.approvedSections || []).filter((x) => x === true || x === 1).length;
        return Math.round((approved / p.sections.length) * 100);
    }
    return 0;
};

export const projectGroup = (p) => p.category || p.folder || 'Workspace';

export const projectName = (p) => p.name || p.projectName || 'Untitled project';
